<template>
  <v-col cols="12" sm="12">
    <v-col cols="6" sm="6">
      <v-toolbar-title>Reportes</v-toolbar-title>
      <br />
      <v-text-field
        v-model="buscar"
        :append-icon="'mdi-select-search'"
        label="Buscar Reporte por Id / Contratista / Descripciòn"
        dense
      ></v-text-field>
    </v-col>
    <v-data-table
      :headers="
        $store.getters.usuario.idRol == 2 ? headersOperador : headersContratista
      "
      :items="tablaReportes"
      item-key="idReporte"
      sort-by="idReporte"
      :search="buscar"
      :header-props="headerProps"
      :footer-props="footerProps"
      no-data-text="No se encontraron registros"
      no-results-text="No se encontraron registros en la búsqueda"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <!-- <v-divider class="mx-4" inset vertical></v-divider> -->
          <v-spacer></v-spacer>
          <!-- <v-tooltip left color="indigo">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                elevation="10"
                small
                fab
                color="indigo"
                dark
                class="mx-2"
                @click="AbrirModal(0)"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark> mdi-plus </v-icon>
              </v-btn>
            </template>
            <span>Armar Reporte</span>
          </v-tooltip> -->
          <insertReporte
            ref="abrirModalInsert_Update"
            @Recargar="getListarReporte()"
          ></insertReporte>
          <v-dialog v-model="dialogDelete" max-width="800px">
            <v-card>
              <v-card-title class="text-h5"
                >¿Está seguro que desea eliminar este Reporte?</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete"
                  >Cancel</v-btn
                >
                <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                  >OK</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <template v-slot:[`item.idTipo`]="{ item }">
        {{ getTextoTipo(item.idTipo) }}
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <!-- <v-tooltip bottom mg="1">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              color="green"
              fab
              x-small
              dark
              class="ml-2"
              @click="editarEjecutor(item)"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>Editar Ejecutor</span>
        </v-tooltip>

        <v-tooltip bottom mg="1">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              color="red"
              fab
              x-small
              dark
              class="ml-2"
              @click="eliminarEjecutor(item)"
            >
              <v-icon>mdi-delete-forever</v-icon>
            </v-btn>
          </template>
          <span>Eliminar Ejecutor</span>
        </v-tooltip> -->
        <v-tooltip left color="orange">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              elevation="10"
              small
              fab
              color="orange"
              dark
              class="mx-2"
              @click="imprimirReporte(item)"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark> mdi-printer </v-icon>
            </v-btn>
          </template>
          <span>Imprimir Reporte</span>
        </v-tooltip>
        <v-tooltip left color="blue">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              elevation="10"
              small
              fab
              color="blue"
              dark
              class="mx-2"
              @click="verDetalleReporte(item)"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark> mdi-eye </v-icon>
            </v-btn>
          </template>
          <span>Ver Detalles</span>
        </v-tooltip>

        <modalReporte ref="modalReporte"></modalReporte>
      </template>
    </v-data-table>
  </v-col>
</template>
<script>
import jsPDF from "jspdf";
import tablaMateriales from "jspdf-autotable";
import tablaMaterialesBobinas from "jspdf-autotable";
import tablaMaterialesMedidores from "jspdf-autotable";
//import insertReporte from "@/modulos/Reportes/componentes/modalReportes.vue";
import modalReporte from "@/modulos/Reportes/componentes/modalReportes.vue";
import axios from "axios";
export default {
  components: {
    modalReporte,
  },
  data: () => ({
    dialogDelete: false,
    headersOperador: [
      {
        text: "Id Remito",
        align: "start",
        sortable: true,
        value: "idRemito",
        class: "black white--text",
      },
      // {
      //   text: "Id Cuadrilla",
      //   value: "idCuadrilla",
      //   class: "black white--text",
      // },
      // {
      //   text: "Id Cajon",
      //   value: "idCajon",
      //   class: "black white--text",
      // },
      {
        text: "Fecha Alta",
        value: "fechaAlta",
        class: "black white--text",
      },
      {
        text: "Tipo",
        value: "idTipo",
        class: "black white--text",
      },
      {
        text: "Acciones",
        value: "actions",
        sortable: false,
        class: "black white--text",
      },
    ],
    headersContratista: [
      {
        text: "Id Remito",
        align: "start",
        sortable: true,
        value: "idRemito",
        class: "black white--text",
      },
      {
        text: "Fecha Alta",
        value: "fechaAlta",
        class: "black white--text",
      },
      { text: "Id Cajon", value: "idCajon", class: "black white--text" },
      {
        text: "Id Cuadrilla",
        value: "idCuadrilla",
        class: "black white--text",
      },
      {
        text: "Id Empresa",
        value: "idEmpresa",
        class: "black white--text",
      },
      {
        text: "Id OT",
        value: "idOT",
        class: "black white--text",
      },
      {
        text: "Tipo",
        value: "idTipo",
        class: "black white--text",
      },
      {
        text: "Cuadrilla",
        value: "integrantesCuadrillas",
        class: "black white--text",
      },
      {
        text: "Acciones",
        value: "actions",
        sortable: false,
        class: "black white--text",
      },
    ],
    headerProps: {
      sortByText: "Ordenar por",
    },
    other: [1, 20, 344, 44444],
    footerProps: {
      itemsPerPageText: "Registros por página",
      pageText: "{0}-{1} de {2}",
      itemsPerPageOptions: [5, 10, 20, 50, 100, { text: "Todos", value: -1 }],
    },
    tablaReportes: [],
    buscar: "",
    Reportes: [],
    editedIndex: -1,
    editedItem: {
      idReporte: "",
      descripcion: 0,
    },
    defaultItem: {
      idReporte: "",
      descripcion: 0,
    },
  }),

  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  mounted() {
    this.getListarReporte();
    this.getRecuperarServicios();
  },
  methods: {
    async verDetalleReporte(reporteSeleccionado) {
      console.log("Detalles reporte");
      this.$refs.modalReporte.verDetalleReporte(reporteSeleccionado);
    },
    async imprimirReporte(reporteSeleccionado) {
      console.log("Datos del remito");
      console.log(reporteSeleccionado);

      var materiales = await this.getDetallesRemitoMateriales(
        reporteSeleccionado.idRemito
      );
      var materialesBobina = await this.getDetallesRemitoMaterialesBobinas(
        reporteSeleccionado.idRemito
      );

      var materialesMedidores = await this.getDetallesRemitoMaterialesMedidores(
        reporteSeleccionado.idRemito
      );

      console.log("Los materiales son");
      console.log(materiales);

      console.log("Los materiales bobina son");
      console.log(materialesBobina);

      const doc = new jsPDF({
        orientation: "portrait",
        unit: "px",
        //format: [4, 2],
        format: "A4",
        margin: { top: 20 },
      });

      const lineaInicial = 70;

      //const lineaInicialSombreado = 80;

      const encabezadoMateriales = ["Matricula", "Descripcion", "Cantidad"];

      const encabezadoMaterialesBobinas = [
        "Bobina",
        "Secuencia Inicio",
        "Secuencia Fin",
        "Cantidad De Metros",
      ];

      const encabezadoMaterialesMedidores = [
        "Matricula",
        "ID Medidor",
        "Descripcion Medidor",
      ];

      //const maxWidth = doc.internal.pageSize.width * 0.9; // Ajusta el ancho máximo para el texto

      const espacioEntreLineas = 20;

      const titulo = "Remito de Materiales";

      const idRemito = "N° Remito: " + reporteSeleccionado.idRemito;

      const idCuadrilla = "N° Cuadrilla: " + reporteSeleccionado.idCuadrilla;
      const integrantesCuadrillas =
        "Integrantes: " + reporteSeleccionado.integrantesCuadrillas;
      const fechaAsignacion =
        "Fecha Creacion: " + reporteSeleccionado.fechaAlta;

      const idOT = "N° OT: " + reporteSeleccionado.idOT;

      const tipoRemito =
        reporteSeleccionado.idTipo === 1 ? "Tipo: Entrega" : "Tipo: Devolucion";

      doc.text(titulo, doc.internal.pageSize.width * 0.63, 37, {
        aling: "right",
      });

      doc.text(
        idRemito,
        doc.internal.pageSize.width * 0.05,
        lineaInicial + espacioEntreLineas * 2,
        {
          aling: "right",
        }
      );

      doc.text(
        idCuadrilla,
        doc.internal.pageSize.width * 0.05,
        lineaInicial + espacioEntreLineas * 3,
        {
          aling: "right",
        }
      );

      doc.text(
        integrantesCuadrillas,
        doc.internal.pageSize.width * 0.05,
        lineaInicial + espacioEntreLineas * 4,
        {
          aling: "right",
        }
      );

      doc.text(
        fechaAsignacion,
        doc.internal.pageSize.width * 0.05,
        lineaInicial + espacioEntreLineas * 5,
        {
          aling: "right",
        }
      );

      doc.text(
        idOT,
        doc.internal.pageSize.width * 0.05,
        lineaInicial + espacioEntreLineas * 6,
        {
          aling: "right",
        }
      );

      doc.text(
        tipoRemito,
        doc.internal.pageSize.width * 0.05,
        lineaInicial + espacioEntreLineas * 7,
        {
          aling: "right",
        }
      );

      const arregloDatosMateriales = Object(materiales).map(function (obj) {
        const datos = [obj.idMaterial, obj.nombre, obj.cantidad];
        return datos;
      });

      const arregloDatosMaterialesBobinas = Object(materialesBobina).map(
        function (obj) {
          const datos = [
            obj.idBobinaT,
            obj.secInicio,
            obj.secFin,
            obj.secFin - obj.secInicio,
          ];
          return datos;
        }
      );

      const arregloDatosMaterialesMedidores = Object(materialesMedidores).map(
        function (obj) {
          const datos = [obj.idMaterial, obj.idMedidor, obj.descripcionMedidor];
          return datos;
        }
      );

      const logo = require("../../assets/Logo_edese_hd(2).png");
      var imgLogo = new Image();
      imgLogo.src = logo;
      doc.addImage(imgLogo, "PNG", 0, 0, 200, 80);

      tablaMateriales(doc, {
        head: [encabezadoMateriales],
        body: arregloDatosMateriales,
        margin: { top: 250 },
      });

      doc.text(
        "------------------------------------------------------------------------------------------------------",
        doc.internal.pageSize.width * 0.05,
        lineaInicial + espacioEntreLineas * 25,
        {
          aling: "left",
        }
      );

      doc.text(
        "Observaciones",
        doc.internal.pageSize.width * 0.4,
        lineaInicial + espacioEntreLineas * 26,
        {
          aling: "center",
        }
      );

      doc.text(
        "----------------------------------",
        doc.internal.pageSize.width * 0.05,
        lineaInicial + espacioEntreLineas * 27,
        {
          aling: "right",
        }
      );

      doc.text(
        "Firma Cuadrilla",
        doc.internal.pageSize.width * 0.12,
        lineaInicial + espacioEntreLineas * 27.7,
        {
          aling: "right",
        }
      );

      doc.text(
        "----------------------------------",
        doc.internal.pageSize.width * 0.6,
        lineaInicial + espacioEntreLineas * 27,
        {
          aling: "left",
        }
      );

      doc.text(
        "Firma Enc. Depósito Contratista",
        doc.internal.pageSize.width * 0.56,
        doc.internal.pageSize.height * 0.99,
        {
          aling: "left",
        }
      );

      doc.addPage();

      tablaMaterialesBobinas(doc, {
        head: [encabezadoMaterialesBobinas],
        body: arregloDatosMaterialesBobinas,
        margin: { top: 50 },
      });

      doc.text(
        "------------------------------------------------------------------------------------------------------",
        doc.internal.pageSize.width * 0.05,
        lineaInicial + espacioEntreLineas * 25,
        {
          aling: "left",
        }
      );

      doc.text(
        "Observaciones",
        doc.internal.pageSize.width * 0.4,
        lineaInicial + espacioEntreLineas * 26,
        {
          aling: "center",
        }
      );

      doc.text(
        "----------------------------------",
        doc.internal.pageSize.width * 0.05,
        lineaInicial + espacioEntreLineas * 27,
        {
          aling: "right",
        }
      );

      doc.text(
        "Firma Cuadrilla",
        doc.internal.pageSize.width * 0.12,
        lineaInicial + espacioEntreLineas * 27.7,
        {
          aling: "right",
        }
      );

      doc.text(
        "----------------------------------",
        doc.internal.pageSize.width * 0.6,
        lineaInicial + espacioEntreLineas * 27,
        {
          aling: "left",
        }
      );

      doc.text(
        "Firma Enc. Depósito Contratista",
        doc.internal.pageSize.width * 0.56,
        doc.internal.pageSize.height * 0.99,
        {
          aling: "left",
        }
      );

      doc.addPage();

      tablaMaterialesMedidores(doc, {
        head: [encabezadoMaterialesMedidores],
        body: arregloDatosMaterialesMedidores,
        margin: { top: 50 },
      });

      doc.text(
        "------------------------------------------------------------------------------------------------------",
        doc.internal.pageSize.width * 0.05,
        lineaInicial + espacioEntreLineas * 25,
        {
          aling: "left",
        }
      );

      doc.text(
        "Observaciones",
        doc.internal.pageSize.width * 0.4,
        lineaInicial + espacioEntreLineas * 26,
        {
          aling: "center",
        }
      );

      doc.text(
        "----------------------------------",
        doc.internal.pageSize.width * 0.05,
        lineaInicial + espacioEntreLineas * 27,
        {
          aling: "right",
        }
      );

      doc.text(
        "Firma Cuadrilla",
        doc.internal.pageSize.width * 0.12,
        lineaInicial + espacioEntreLineas * 27.7,
        {
          aling: "right",
        }
      );

      doc.text(
        "----------------------------------",
        doc.internal.pageSize.width * 0.6,
        lineaInicial + espacioEntreLineas * 27,
        {
          aling: "left",
        }
      );

      doc.text(
        "Firma Enc. Depósito Contratista",
        doc.internal.pageSize.width * 0.56,
        doc.internal.pageSize.height * 0.99,
        {
          aling: "left",
        }
      );

      const hoy = new Date();
      doc.save(
        hoy.getDate() +
          hoy.getMonth() +
          hoy.getFullYear() +
          hoy.getTime() +
          ".pdf"
      );
    },

    agregarTexto(doc, texto, x, y) {
      const textoDividido = doc.splitTextToSize(
        texto,
        doc.internal.pageSize.width * 0.9
      );
      doc.text(textoDividido, x, y);
    },

    async getDetallesRemitoMateriales(idRemito) {
      console.log("Ingreso en los detalles del cajon");
      this.url =
        this.$store.getters.urlBase +
        "Material/recuperarRemitoMateriales?idRemito=" +
        idRemito;

      this.listaMaterialesCajon = [];
      this.listaMaterialesOriginales = [];
      //this.cajones = listaCajon;
      console.log(this.url);
      var respuesta = await axios
        .get(this.url)
        .then((response) => {
          console.log("Respuesta de recuperar materiales cajon");
          console.log(response.data);
          this.listaMaterialesCajon = response.data;
          console.log(this.listaMaterialesCajon);
          return response.data;
          //this.tablaMaterialesCajonModificacion = response.data;
        })
        .catch((error) => {
          console.log(error.response);
          if (error.response == undefined) {
            this.mensajeSnack = "Error de Conexion";
          } else {
            if (error.response.status === 401) {
              this.mensajeSnack =
                "No posee autorizacion para ver esta informacion";
            } else {
              if (error.response.data != "") {
                this.mensajeSnack = error.response.data;
              }
            }
          }
          this.loadingButton = false;
          this.colorSnack = "red";
          this.Showsnackbar = true;
        });

      // this.tablaMaterialesCajonModificacion = respuesta;
      // this.listaMaterialesCajon = respuesta;
      // this.loadingButton = false;
      // respuesta.forEach((material) => {
      //   this.listaMaterialesOriginales.push({
      //     idMaterial: material.idMaterial,
      //     cantidad: material.cantidadSaldo,
      //   });
      // });

      // console.log("Lo que hay en la tabla Materiales para la modificacion es");
      // console.log(this.tablaMaterialesCajonModificacion);

      // console.log("Los materiales originales son: ");
      // console.log(this.listaMaterialesOriginales);

      return respuesta;
    },

    async getDetallesRemitoMaterialesBobinas(idRemito) {
      console.log("Ingreso en los detalles del materiales bobinas");
      this.url =
        this.$store.getters.urlBase +
        "Material/recuperarRemitoMaterialesBobinas?idRemito=" +
        idRemito;

      this.listaMaterialesCajon = [];
      this.listaMaterialesOriginales = [];
      //this.cajones = listaCajon;
      console.log(this.url);
      var respuesta = await axios
        .get(this.url)
        .then((response) => {
          console.log("Respuesta de recuperar bobinas remito");
          console.log(response.data);
          this.listaMaterialesCajon = response.data;
          console.log(this.listaMaterialesCajon);
          return response.data;
          //this.tablaMaterialesCajonModificacion = response.data;
        })
        .catch((error) => {
          console.log(error.response);
          if (error.response == undefined) {
            this.mensajeSnack = "Error de Conexion";
          } else {
            if (error.response.status === 401) {
              this.mensajeSnack =
                "No posee autorizacion para ver esta informacion";
            } else {
              if (error.response.data != "") {
                this.mensajeSnack = error.response.data;
              }
            }
          }
          this.loadingButton = false;
          this.colorSnack = "red";
          this.Showsnackbar = true;
        });
      return respuesta;
    },

    async getDetallesRemitoMaterialesMedidores(idRemito) {
      console.log("Ingreso en los detalles del materiales bobinas");
      this.url =
        this.$store.getters.urlBase +
        "Material/recuperarRemitoMaterialesMedidores?idRemito=" +
        idRemito;

      this.listaMaterialesCajon = [];
      this.listaMaterialesOriginales = [];
      //this.cajones = listaCajon;
      console.log(this.url);
      var respuesta = await axios
        .get(this.url)
        .then((response) => {
          console.log("Respuesta de recuperar bobinas remito");
          console.log(response.data);
          this.listaMaterialesMedidores = response.data;
          console.log(this.listaMaterialesMedidores);
          return response.data;
          //this.tablaMaterialesCajonModificacion = response.data;
        })
        .catch((error) => {
          console.log(error.response);
          if (error.response == undefined) {
            this.mensajeSnack = "Error de Conexion";
          } else {
            if (error.response.status === 401) {
              this.mensajeSnack =
                "No posee autorizacion para ver esta informacion";
            } else {
              if (error.response.data != "") {
                this.mensajeSnack = error.response.data;
              }
            }
          }
          this.loadingButton = false;
          this.colorSnack = "red";
          this.Showsnackbar = true;
        });
      return respuesta;
    },

    getTextoTipo(idTipo) {
      console.log("El tipo es");
      console.log(idTipo);
      return idTipo === 1 ? "Entrega" : "Devolucion";
    },
    abrirAsignarTareas(datos) {
      this.$router.push({
        name: "Asignar Tarea a Reporte",
        params: { datos },
      });
    },
    AbrirModal(tipo) {
      // console.log(tipo)
      this.$refs.abrirModalInsert_Update.openModal(tipo);
    },
    AbrirModalModificacion(item) {
      this.$refs.abrirModalInsert_Update.openModalModificacion(item);
    },
    deleteItem(item) {
      this.editedIndex = this.Reportes.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.Reportes.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async getListarReporte() {
      console.log("Los datos del usuario son:");
      console.log(this.$store.getters.usuario.idContratista);

      if (this.$store.getters.usuario.idRol == 2) {
        this.url =
          this.$store.getters.urlBase + "Remito/recuperarRemitosOperador";
      }
      if (this.$store.getters.usuario.idRol == 3) {
        this.url = `${this.$store.getters.urlBase}Remito/recuperarRemitosXIdContratista?idContratista=${this.$store.getters.usuario.idContratista}&idDistrito=${this.$store.getters.usuario.idDistrito}`;
      }

      console.log("La url es:");
      console.log(this.url);

      var obj = {
        idContratista: this.$store.getters.usuario.idContratista,
        idDistrito: this.$store.getters.usuario.idDistrito,
      };

      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        url: this.url,
      };
      var respuesta = await axios(this.url, obj, options);
      if (respuesta.status === 200) {
        console.log("la lista de Reporte es:");
        console.log(respuesta.data);
        this.tablaReportes = respuesta.data;
        // this.getListarDiasMantenimiento();
      } else {
        // this.colorSnack = "red";
        // this.mensajeSnack = respuesta.data;
        // this.Showsnackbar = true;
        console.log("Error");
      }
    },

    async getRecuperarServicios() {
      this.url = this.$store.getters.urlBase + "Gang/servicios";
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        url: this.url,
      };
      var respuesta = await axios(this.url, options);
      if (respuesta.status === 200) {
        console.log("Los servicios son");
        console.log(respuesta.data);
        //this.Reportes = respuesta.data;
        // this.getListarDiasMantenimiento();
      } else {
        // this.colorSnack = "red";
        // this.mensajeSnack = respuesta.data;
        // this.Showsnackbar = true;
        console.log("Error");
      }
    },
  },
};
</script>
